import { buildCanonicalPath } from '@app/util/buildCanonicalPath'
import { useRootDomain } from '@app/util/hooks/useRootDomain'
import { useLocation, useSearchParams } from 'wouter'

/** Canonical page URL (pathname + allowed query: tab, page, slug). Used for rel=canonical and og:url. */
export const useCanonicalUrl = (): string => {
  const rootDomain = useRootDomain()
  const [location] = useLocation()
  const [searchParams] = useSearchParams()
  const pathname = location.split('?')[0] ?? location
  return `${rootDomain}${buildCanonicalPath(pathname, searchParams)}`
}
